import * as m from "mithril";

import './Stars.scss';

export default function StarsComponent(): m.Component<{value:number}> {
    return {
        view(vnode) {
            let percentage = Math.trunc(100 * (vnode.attrs.value / 5));
            let widthClass = "stars-w-" + percentage;

            return m("i", {"class": "stars " + widthClass});
        }
    }
}